import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		edit: {
			panel: {
				// height: '280px',
				width: '70%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		list: {
			config: {
				fields: {
					id: {
						config: {
							visible: false,
							width: '250px'
						}
					},
					user: {},
					for_all: {},
					document_type: {},
					field: {},
					template: {}
				}
			},
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		select: {
			panel: {
				width: '70%'
			},
			config: {
				fields: {
					template: {}
				}
			},
			component: defineAsyncComponent(() => import('./forms/Select.vue'))
		}
	}
}